import { createAsyncAction, createAction } from 'typesafe-actions';
import type { ViewsModels } from '../types';

export const FETCH_RELATED_SERVICES = createAsyncAction(
  'product/FETCH_RELATED_SERVICES/request',
  'product/FETCH_RELATED_SERVICES/success',
  'product/FETCH_RELATED_SERVICES/failure',
  'product/FETCH_RELATED_SERVICES/cancel',
)<void, ViewsModels.RelatedServiceSuccessResponse, Error, void>();

export const RESET_RELATED_SERVICES = createAction('product/RESET_RELATED_SERVICES')();

export const RELATED_SERVICE_ITEM_IN_VIEWPORT = createAction(
  'ui/RELATED_SERVICE_ITEM_IN_VIEWPORT',
)<number>();

export const RELATED_SERVICE_ITEM_CLICK = createAction(
  'ui/RELATED_SERVICE_ITEM_CLICK',
)<ViewsModels.RelatedService>();
